import axios from 'axios';

const axiosInstance = axios.create({
  baseURL: process.env.REACT_APP_API_END_POINT,
});

axiosInstance.interceptors.request.use(
  config => {
    let accessToken = ``;
    if (sessionStorage.hasOwnProperty('access_token')) {
      accessToken = sessionStorage.getItem('access_token') as string;
    } else {
      accessToken = localStorage.getItem('access_token') as string;
    }
    if (accessToken) {
      config.headers = {
        authorization: `Bearer ${accessToken}`,
        Accept: 'application/json',
      };
    }
    return config;
  },
  error => {
    return Promise.reject(error);
  },
);

axiosInstance.interceptors.response.use(
  response => response,
  async error => {
    const status = error?.response?.status;
    const currentPath = window.location.pathname;

    const clearStorage = () => {
      localStorage.clear();
      sessionStorage.clear();
    };

    if (status === 401 && currentPath !== '/sign-in') {
      clearStorage();
      window.location.href = '/sign-in';
    }

    if (status === 503 && currentPath !== '/maintenance') {
      clearStorage();
      window.location.href = '/maintenance';
    }
    return Promise.reject(error);
  },
);

export const apiGet = axiosInstance.get;
export const apiPost = axiosInstance.post;
export const apiPut = axiosInstance.put;
export const apiDelete = axiosInstance.delete;
export const apiPatch = axiosInstance.patch;

export default axiosInstance;
